export default "__VITE_ASSET__Cwan1Hg___"